import { DataGrid } from '@mui/x-data-grid'
import React from 'react'
import dayjs from "dayjs"
import { describeDebtOwner, hasDebtOwnerAttribution } from './debtOwner'

const CreditReportsHistoryTable = ({ data, onViewPdf, pdfLoading, loadingReportId }) => {
  const columns = [
    {
      field: 'reportDate',
      headerName: 'Pull Date',
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const date = params.row.reportDate
        return date ? dayjs(date).format('MM/DD/YYYY HH:mm') : 'N/A'
      }
    },
    {
      // Shown only when the co-applicant's reports are listed beside the applicant's.
      field: 'source',
      headerName: 'Whose report',
      flex: 1,
      minWidth: 130,
      sortable: false,
      renderCell: (params) => describeDebtOwner(params.row.source)
    },
    {
      field: 'creditScore',
      headerName: 'Credit Score',
      flex: 1,
      minWidth: 120,
      // A file can come back with no score — a thin/unscoreable consumer, or no file at all
      // (freeze, no-hit). That is "no score available", not a score of zero, and showing a bare
      // 0 read as a catastrophic score. Matches the Pull Date column's N/A treatment.
      renderCell: (params) => {
        const score = params.row.creditScore
        return score > 0 ? score : 'N/A'
      }
    },
    {
      field: 'provider',
      headerName: 'Provider',
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const provider = params.row.provider || 'Experian'
        return provider.toUpperCase()
      }
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const isThisRowLoading = loadingReportId === params.row._id && pdfLoading
        return (
          <button
            onClick={() => onViewPdf(params.row._id)}
            disabled={isThisRowLoading}
            className="px-3 py-1 text-sm text-primary-main hover:bg-surface rounded-md border border-divider transition-colors disabled:opacity-50"
          >
            {isThisRowLoading ? 'Loading...' : 'View PDF'}
          </button>
        )
      }
    }
  ]

  return (
    <div className="w-full">
      <DataGrid
        rows={data || []}
        columns={columns}
        getRowId={(row) => row._id || row.id}
        columnVisibilityModel={{ source: hasDebtOwnerAttribution(data) }}
        disableSelectionOnClick
        disableColumnMenu
        hideFooter
        autoHeight
        sx={{ border: 'none' }}
      />
    </div>
  )
}

export default CreditReportsHistoryTable
